/* eslint-disable */
/**
 * This store module used to store various button related data into
 * vuex store like tab_button, polk_button etc
 */
const state = {
  buttonsData: null,
  quoteSummaryData: null,
};

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const getters = {
  buttonsData(state) {
    return state.buttonsData;
  },
};

const mutations = {
  /**
   * Set button data in vuex store
   * @param {*} state vuex state
   * @param {*} buttonsData buttonData form pageData object
   */
  setButtonData(state, buttonsData) {
    state.buttonsData = buttonsData;
  },
  /**
   * Set quote summary data into vuex store
   * @param {*} state vuex state
   * @param {*} summaryData quoteSummary data from pageData object
   */
  setSummaryData(state, summaryData) {
    state.quoteSummaryData = summaryData;
  },
};

const actions = {
  /**
   * call setButtonData mutation to store button data in vuex store
   * @param {*} pageData pageData from page API response
   */
  setButtonDataAction({ commit }, pageData) {
    if (pageData.tab_buttons) {
      commit('setButtonData', pageData.tab_buttons);
    }
  },
  /**
   * call setSummaryData mutation to store summary data in vuex store
   * @param {*} pageData pageData from page API response
   */
  setQuoteSummaryAction({ commit }, pageData) {
    commit('setSummaryData', pageData.quote_summary);
  },
};

/**
 * export module to main store.js
 */
export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/button.js